// Modalidades de pagamento que o usuário pode usar (Cadastro de Clientes e Gerar Cobrança).
// Sem nenhuma permissão "modalidade:..." o usuário usa todas (o comportamento de sempre).
export const TODAS_MODALIDADES = ['cpfl', 'asaas', 'pix'];

export function modalidadesPermitidas(permissoes) {
  const marcadas = (permissoes || [])
    .map((p) => String(p).toLowerCase())
    .filter((p) => p.startsWith('modalidade:'))
    .map((p) => p.slice('modalidade:'.length))
    .filter((id) => TODAS_MODALIDADES.includes(id));
  return marcadas.length ? marcadas : TODAS_MODALIDADES.slice();
}


function textoNormalizado(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export function modalidadesPorUsuario(user) {
  const roles = Array.isArray(user?.roles)
    ? user.roles
    : [user?.roles].filter(Boolean);

  const ehAtendente = roles.some(
    role => textoNormalizado(role) === 'atendente'
  );

  const permissoes = Array.isArray(user?.permissions)
    ? user.permissions.map(textoNormalizado)
    : [];

  const setores = user?.setores ?? user?.sector ?? user?.department ?? '';
  const setoresTexto = typeof setores === 'string'
    ? setores
    : JSON.stringify(setores || {});

  const ehOdontologia =
    permissoes.includes('checklist:odontologia') ||
    textoNormalizado(setoresTexto).includes('odontolog');

  if (ehAtendente && ehOdontologia) {
    return ['pix'];
  }

  return modalidadesPermitidas(user?.permissions);
}
